import React from 'react';

interface FormDocumentRowProps<T extends string = string> {
  label: string;
  name: T;
  value: string | null | undefined;
  isEditable?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholderText?: string;
  labelWidthClass?: string; // Optional custom width for labels
  className?: string;
}

export const FormDocumentRow = <T extends string>({
  label,
  name,
  value = '',
  isEditable = true,
  onChange,
  placeholderText = '(ကွက်လပ်)',
  labelWidthClass = 'sm:w-80',
  className = '',
}: FormDocumentRowProps<T>) => {
  const displayValue = value || '';

  return (
    <div className={`flex flex-col sm:flex-row sm:items-end gap-2 py-2 ${className}`}>
      <label className={`text-slate-800 font-medium text-sm shrink-0 ${labelWidthClass}`}>
        {label}
      </label>

      <div className="flex-grow w-full min-w-0">
        {!isEditable ? (
          <span className="text-slate-900 font-medium text-sm block min-h-[1.5rem] px-1 bg-transparent border-0 border-b border-dashed border-slate-400">
            {displayValue || (
              <span className="text-slate-300 italic font-normal">{placeholderText}</span>
            )}
          </span>
        ) : (
          <input
            type="text"
            name={name}
            value={displayValue}
            onChange={onChange}
            className="w-full bg-transparent border-0 border-b border-dashed border-slate-400 p-0 pb-0.5 text-sm text-slate-900 focus:outline-none focus:ring-0 font-medium leading-relaxed"
          />
        )}
      </div>
    </div>
  );
};